import { create } from 'zustand';

/** Where the Support dialog was opened from (analytics `source`). */
export type SupportDialogSource = 'settings_menu';

interface SupportDialogState {
  open: boolean;
  source: SupportDialogSource | null;
  openSupport: (source: SupportDialogSource) => void;
  closeSupport: () => void;
}

/**
 * Open state of the Support dialog. It lives in shared so the sidebar menu
 * (shared layout) can open a dialog that is implemented by the support module
 * and mounted at the app root.
 */
export const useSupportDialogStore = create<SupportDialogState>()((set) => ({
  open: false,
  source: null,
  openSupport: (source) => {
    set({ open: true, source });
  },
  closeSupport: () => {
    set({ open: false });
  },
}));
